import { useState, useEffect } from 'react'

const PersonalNav = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [activeSection, setActiveSection] = useState('home')
  const [mobileOpen, setMobileOpen] = useState(false)

  const navItems = [
    { id: 'home', label: '~/' },
    { id: 'about', label: './skills' },
    { id: 'work', label: './work' },
    { id: 'contact', label: './contact' }
  ]

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)

      // If scrolled to bottom, contact is always active
      const atBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 50)
      if (atBottom) {
        setActiveSection('contact')
        return
      }

      const sections = ['home', 'about', 'work', 'contact']
      const currentSection = sections.find(section => {
        const element = document.getElementById(section)
        if (element) {
          const rect = element.getBoundingClientRect()
          return rect.top <= 150 && rect.bottom >= 150
        }
        return false
      })

      if (currentSection) {
        setActiveSection(currentSection)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
    setMobileOpen(false)
  }

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled || mobileOpen
        ? 'bg-[#0A0A0F]/95 backdrop-blur-xl border-b border-[#1E1E2E]'
        : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14">

          {/* Logo - terminal style */}
          <button
            onClick={() => scrollToSection('home')}
            className="font-mono text-base group flex items-center gap-2"
          >
            <span className="text-[#00FFE0]">ishay</span>
            <span className="text-[#555570]">@</span>
            <span className="text-[#8888A0]">builder</span>
            <span className="text-[#00FFE0] cursor-blink">_</span>
          </button>

          {/* Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`font-mono text-sm px-3 py-1.5 rounded transition-all duration-300 ${
                  activeSection === item.id
                    ? 'text-[#00FFE0] bg-[rgba(0,255,224,0.08)]'
                    : 'text-[#8888A0] hover:text-[#E0E0E8] hover:bg-[#1A1A26]'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* CTA */}
          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block font-mono text-sm px-4 py-1.5 border border-[#00FFE0] text-[#00FFE0] rounded hover:bg-[rgba(0,255,224,0.1)] transition-all duration-300"
          >
            $ hire-me
          </button>

          {/* Mobile menu */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden font-mono text-[#00FFE0] text-sm"
          >
            {mobileOpen ? '[x]' : '[=]'}
          </button>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-[#1E1E2E] space-y-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`block w-full text-left font-mono text-sm px-3 py-2 rounded transition-all ${
                  activeSection === item.id
                    ? 'text-[#00FFE0] bg-[rgba(0,255,224,0.08)]'
                    : 'text-[#8888A0] hover:text-[#E0E0E8]'
                }`}
              >
                <span className="text-[#555570] mr-2">&gt;</span>
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left font-mono text-sm px-3 py-2 text-[#00FFE0] mt-2"
            >
              <span className="text-[#555570] mr-2">$</span>
              hire-me --now
            </button>
          </div>
        )}
      </div>
    </nav>
  )
}

export default PersonalNav
